import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

export default function JoinTerms(props) {
  const { open, handleClose } = props;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="draggable-dialog-title">개인정보 수집 약관</DialogTitle>
      <DialogContent dividers>
        정보통신망법 규정에 따라 ㈜도화엔지니어링에 회원가입을 신청하시는 분들께 처리하는 개인정보의 목적 및 처리하는 개인정보의 항목, 개인정보의 보유 및 이용기간을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.
        <br />
        <br />
        1. 개인정보의 처리목적
        <br />
        <br />
        ㈜도화엔지니어링은 개인정보를 다음의 목적을 위해 처리합니다. 처리되는 개인정보는 다음의 목적이외의 용도로는 이용되지 않으며 이용 목적이 변경될 시에는 사전 동의를 구할 예정입니다.
        <br />
        <br />- 처리목적 : 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 만 14세 미만 가입자의 법정대리인 동의 여부 확인, 불만처리 등 민원 처리, 고지사항 전달을
        목적으로 개인정보를 처리합니다.
        <br />
        <br />
        2. 처리하는 개인정보의 항목 및 수집방법
        <br />
        <br />
        ㈜도화엔지니어링은 서비스 제공을 위해 필요한 최소한의 범위 내에서 다음과 같은 개인정보를 처리하고 있습니다. 처리하는 개인정보의 항목 중 ‘선택항목’은 회원에게 더 나은 서비스를 제공하기 위해 추가로 수집하는 정보입니다. 회원이 원하지
        않을 경우 해당 추가정보는 수집하지 않으며, 이로 인한 서비스 이용 상의 제한은 없습니다.
        <br />
        <br />- 필수항목 : 아이디(이메일), 비밀번호, 이름, 휴대폰번호, E-mail
        <br />- 수집방법 : 회원가입 페이지
        <br />
        <br />
        3. 개인정보의 보유 및 이용 기간
        <br />
        <br />
        회원의 개인정보는 원칙적으로 개인정보의 처리목적이 달성되거나 해당 서비스가 폐지되면 지체 없이 파기합니다.
        <br />
        <br />- 법령에 따른 보관
        <br />
        <br />
        1. 전자상거래 등에서의 소비자 보호에 관한 법률 <br />
        가. 계약 또는 청약 철회 등에 관한 기록 : 5년
        <br />
        나. 대금결제 및 재화 등의 공급에 관한 기록 : 5년
        <br />
        다. 소비자의 불만 또는 분쟁 처리에 관한 기록 : 5년
        <br />
        <br />
        4. 동의를 거부할 권리가 있다는 사실과 동의 거부에 따른 불이익 내용
        <br />
        <br />
        이용자는 위와 같은 개인정보 수집.이용에 대해 동의를 거부할 권리가 있습니다. 단, ‘필수항목’에 대한 동의 거부 시에는 회원가입이 제한됩니다.
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
